export const SET_OWNERS = 'SET_OWNERS';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_FETCHING_ORGANIZATION_POWER_BUYERS =
  'SET_IS_FETCHING_ORGANIZATION_POWER_BUYERS';
export const SET_ORGANIZATION_POWER_BUYERS = 'SET_ORGANIZATION_POWER_BUYERS';
export const SET_IS_FETCHING_AGENTS = 'SET_IS_FETCHING_AGENTS';
export const SET_AGENTS = 'SET_AGENTS';
